
import Hierarchy3 from "../../../assets/filled/Hierarchy3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Hierarchy3Icon({ className, dataTestid = "Hierarchy3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Hierarchy3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
